import React from 'react';
import { Typography, GlobalLink, Violator } from '@hpstellar/core';

import AboveTheFoldOnlyServerRender from '../../../shared/components/above-the-fold-only-server-render';
import BvScript from '../../../bv/components/bv-script';
import BvRating from '../../../bv/components/bv-rating';
import { NAV_SECTIONS } from '../constants';
import withPageComponents from '../../../page/components/with-page-components';
import SustainabilityLogo from '../../../product/components/sustainability-logo';
import ConditionalWrapper from '../../../shared/components/conditional-wrapper';
import ConfigurationBadge from '../cto-configurations/configuration-badge';
import { Helpers } from '../../../core/src/helpers';
import AllianceBadge from '../../../product/components/alliance-badge';

import './title-section.less';

const { reviews } = NAV_SECTIONS;

const focusReviewsSection = () => {
    try {
        document.getElementById('ratings-summary').click();
    } catch (e) {}
};
const EMPTY_OBJ = {};

export const ProductTitle = withPageComponents(
    ({ seo, productInitial, titleLinkProps, typographyProps = EMPTY_OBJ }) => {
        const { h1Tag } = seo || EMPTY_OBJ;
        const { to: titleTo, useRelativePath, ...restTitleLinkProps } = titleLinkProps || EMPTY_OBJ;
        return (
            <ConditionalWrapper
                condition={!!titleTo}
                wrapper={children => (
                    <GlobalLink
                        to={useRelativePath ? Helpers.getRelativePath(titleTo) : titleTo}
                        {...restTitleLinkProps}
                    >
                        {children}
                    </GlobalLink>
                )}
            >
                <Typography
                    className="pdp-title"
                    variant="titleL"
                    tag={'h1'}
                    dangerouslySetInnerHTML={Helpers.createMarkup(h1Tag || productInitial.name)}
                    {...typographyProps}
                />
            </ConditionalWrapper>
        );
    },
    { components: ['productInitial'], seo: true },
);

export const ReviewSection = withPageComponents(
    ({ productInitial, bazaarVoiceProps = {}, templateKey, device, shadowCTO }) => {
        const { renderOn = 'load', idleBuffer = 1000, robots = true } = bazaarVoiceProps || EMPTY_OBJ;

        const { dte_facet_OS } = productInitial || EMPTY_OBJ;
        const showSeparator = productInitial.usageLabel?.length > 0;

        return (
            <>
                {/**Load BV script during an idle period*/}
                <AboveTheFoldOnlyServerRender
                    robots={robots}
                    renderOn={renderOn}
                    idleBuffer={idleBuffer}
                    componentKey={reviews.key}
                >
                    <BvScript sku={productInitial.sku} templateKey={templateKey} />
                </AboveTheFoldOnlyServerRender>
                <div className={'review-section'}>
                    <BvRating sku={productInitial.sku} />

                    {productInitial.usageLabel && device !== 'mobile' && (
                        <>
                            {!shadowCTO && (
                                <AllianceBadge
                                    osBadgeKey={dte_facet_OS}
                                    seperator={showSeparator && <span className="alliance-badge-separator">|</span>}
                                />
                            )}
                            <Violator value={productInitial.usageLabel} />
                        </>
                    )}
                </div>
            </>
        );
    },
    { components: ['productInitial'], device: true },
);

const titleSection = ({
    productInitial,
    bazaarVoiceProps = {},
    titleLinkProps,
    templateKey,
    pdpShadowCTO,
    device,
    showFor = [],
    v2,
}) => {
    const { shadowCTOEnabled } = pdpShadowCTO || {};
    const { facet_aipc } = productInitial || EMPTY_OBJ;

    if (!showFor || (showFor.length > 0 && !showFor.includes(device)) || !productInitial) {
        return null;
    }

    return (
        <div className={`pdp-title-section${v2 ? ' v2' : ''}`}>
            {!v2 && (
                <ReviewSection
                    productInitial={productInitial}
                    bazaarVoiceProps={bazaarVoiceProps}
                    templateKey={templateKey}
                    device={device}
                />
            )}
            {!v2 && (
                <SustainabilityLogo
                    sustainabilityAttribute={productInitial.sustainability_logo_attribute}
                    enableTooltip={true}
                />
            )}
            {!shadowCTOEnabled && <ProductTitle titleLinkProps={titleLinkProps} />}

            {productInitial.usageLabel && device === 'mobile' ? (
                <div className="mobile-usage">
                    <div>
                        <AllianceBadge
                            aiBadgeKey={facet_aipc}
                            variant={productInitial?.usageLabel?.length > 0 ? 'vertical' : ''}
                        />
                        {v2 && <ConfigurationBadge />}
                    </div>

                    <Violator className="mobile-usage-violator" value={productInitial.usageLabel} small />
                </div>
            ) : (
                <>
                    <AllianceBadge aiBadgeKey={facet_aipc} variant="title" />
                    {v2 && <ConfigurationBadge />}
                </>
            )}
        </div>
    );
};

export default withPageComponents(titleSection, {
    components: ['product', 'productInitial', 'pdpShadowCTO'],
    device: true,
});
